import type { I18nService } from '@recruitee/i18n';
import type { PaymentInterval } from '@recruitee/subscription-types';

export function getPaymentIntervalText(
  interval: PaymentInterval,
  i18n: I18nService,
  options?: { short: boolean },
) {
  const { short } = options || {};
  switch (interval) {
    case 1:
      return i18n.translate(
        short
          ? 'app.pricing.payment_interval_short.monthly'
          : 'app.pricing.payment_interval.monthly',
      );
    case 12:
      return i18n.translate(
        short ? 'app.pricing.payment_interval_short.yearly' : 'app.pricing.payment_interval.yearly',
      );
    case 24:
    case 36:
      return i18n.translate(
        short
          ? 'app.pricing.payment_interval_short.every_x_years'
          : 'app.pricing.payment_interval.every_x_years',
        {
          interval: interval / 12,
        },
      );
    default:
      return i18n.translate(
        short
          ? 'app.pricing.payment_interval_short.every_x_months'
          : 'app.pricing.payment_interval.every_x_months',
        { interval },
      );
  }
}
